export const importantDates = ({ caseDetails: { data: { importantDates: data = [] } } }) => (
  data.map(({
    dt,
    id,
    location,
    name,
    timeNotSet,
  }) => ({
    date: dt,
    id,
    location,
    name,
    showTime: !timeNotSet,
  }))
);

export const debtorsList = ({ caseDetails: { data: { debtors = [] } } }) => (
  debtors.map(({
    data: { name } = {},
    petitionDate,
  }, index) => ({
    id: index,
    name,
    petitionDate,
  }))
);

export const linksList = ({ caseDetails: { data: { additionalLinks = [] } } }) => (
  additionalLinks.map(({
    url,
    name,
  }, index) => ({
    id: index,
    link: url,
    title: name,
  }))
);

export const documentsList = ({ caseDetails: { data: { additionalDocuments = [] } } }) => (
  additionalDocuments.map(({
    file,
    name,
  }, index) => ({
    id: index,
    link: file,
    title: name,
  }))
);

export const paragraphsList = ({ caseDetails: { data: { additionalInformation = [] } } }) => (
  additionalInformation.map((text, index) => ({
    id: index,
    text,
  }))
);

export const claimAgent = ({ caseDetails: { data: { claimAgent: data } } }) => data;

export const counselForDebtor = ({ caseDetails: { data: { counselForDebtor: data } } }) => data;

export const court = ({ caseDetails: { data: { court: data } } }) => data;

export const usTrustee = ({ caseDetails: { data: { usTrustee: data } } }) => data;

export const name = ({ caseDetails: { data: { name: data } } }) => data;

export const filingDate = ({ caseDetails: { data: { filingDate: data } } }) => data;

export const caseNumber = ({ caseDetails: { data: { caseNumber: data } } }) => data;



// WEBPACK FOOTER //
// ./src/store/selectors/caseDetails.js